import {
    Service
  } from '../service.js'
  import {
    env
  } from '../env.js'

  import { toastUtils } from '../util/toast.utils.js';
  
  class ProcessoService extends Service {
    constructor(controleDeInstancia) {
      super(controleDeInstancia);
  
      this.url = env.url + "processo";
      
      this.controladoresDeInstancia = {
        listar: new AbortController(),
        cadastrar: new AbortController(),
        enviar: new AbortController()
      }
    }
  
    async listar(objetoDeFiltros, controlador) {
      this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
      return super.get(`${this.url}` + queryString, this.controladoresDeInstancia.listar);
    }

    async adquirirPorId(processoId, controlador) {
      this.controladoresDeInstancia.listar = this.selecionarControlador(controlador);
      return super.get(`${this.url}/${processoId}`, this.controladoresDeInstancia.listar);
    }

    async cadastrar(modelo, controlador) {
      this.controladoresDeInstancia.cadastrar = this.selecionarControlador(controlador);
      const response = await super.post(this.url, modelo, this.controladoresDeInstancia.cadastrar);
      if (response.ok) {
          return response.json();
      } else {
          toastUtils.dangerToast("Não foi possível cadastrar o processo.");
          throw new Error('HTTP ' + response.status);
      }
    }

    async editar(modelo, controlador) {
      this.controladoresDeInstancia.editar = this.selecionarControlador(controlador);
      const response = await super.patch(`${this.url}`, modelo, this.controladoresDeInstancia.editar);
      if (response.ok) {
          return response.json();
      } else {
          toastUtils.dangerToast("Não foi possível cadastrar o processo.");
          throw new Error('HTTP ' + response.status);
      }
    }

    async excluir(processo, controlador) {
      if (!processo.id) {
        console.warn('WARN: Objeto não pode ser apagado pois não possui id;');
      } else {
        let url = `${this.url}`;
        return await this.delete(url, processo, controlador);
      }
    }

    async transferirResponsavel(objetoTransferenciaResponsavel) {
      const url = this.url.concat("/transferir-responsavel")
      const response = await super.post(url, objetoTransferenciaResponsavel);
      if (response.ok) {
          return response;
      } else {
          toastUtils.dangerToast("Não foi possível transferir o responsável.");
          throw new Error('HTTP ' + response.status);
        }
    }
    async concluir(processoId, motivoBaixa) {
      try {
        const response = await super.post(this.url + `/baixar`, {
          processoId,
          motivoBaixa
        });

        if (response.ok) {
          toastUtils.successToast("Negócio concluído com sucesso!");
          return true;
        } else {
          toastUtils.dangerToast("Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações.")
        }
      } catch {
        toastUtils.dangerToast("Ocorreu um erro durante a conclusão. Por favor contate nosso suporte para mais informações.")
        return false;
      }
    }

    async enviarFormulario(body, controlador) {
      this.controladoresDeInstancia.enviar = this.selecionarControlador(controlador);
      const url = this.url.concat("/enviar-formulario")
      const response = await super.post(url, body);
      if (response.ok) {
          return;
      } else {
          toastUtils.dangerToast("Não foi possível realizar o envio do formulário.");
          throw new Error('HTTP ' + response.status);
        }
    }

    async buscarProgresso(objetoDeFiltros) {
      const queryString = this.converterObjetoDeFiltrosParaURIEncodedString(objetoDeFiltros);
      const url = `${this.url}/buscar-progresso${queryString}`;
      return await super.get(url);
    }

    async enviarProgresso(id) {
      const url = this.url.concat("/enviar-progresso/", id)
      await super.post(url, {});
    }

    async editarPrevisaoConclusao(body) {
      try {
        if(!body.id || !body.dataPrevisaoConclusao) throw new Error("Id do processo ou nova data de previsão não informados;")
        const url = `${this.url}/editar-previsao-conclusao`;
        const response =  await super.patch(url,body);
        const json = await response.json();
        if(!response.ok) {
          throw new Error(json.message? json.message : json);
        }
        return json;
      } catch (e) {
        throw new Error(e);
      }
    }
  }
  
  export const processoService = new ProcessoService();